import React, { Fragment } from 'react';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import styles from '../../comparison-grid.module.less';
import { getPaginationEntities, getPaginationPayload } from '../compare-grid-pagination-util';
export var CompareGridPaginationMobile = function CompareGridPaginationMobile(_ref) {
  var canAdd = _ref.canAdd,
      entitiesToCompare = _ref.entitiesToCompare,
      maxEntitiesToShow = _ref.maxEntitiesToShow,
      paginationItemIndex = _ref.paginationItemIndex,
      tabName = _ref.tabName,
      updatePaginationItemIndex = _ref.updatePaginationItemIndex,
      shouldEnableAddEntity = _ref.shouldEnableAddEntity;
  var totalEntities = entitiesToCompare.length;
  /**
   * The conditions for pagination on the 'editable' tab is different for desktop vs mobile
   *
   * For mobile:
   * - the AddCard column should be treated like regular card columns (i.e. totalColumns = totalEntities + 1).
   * We do not want it to be an extra column because we want 2 columns at most in mobile (having an extra column will make it 3)
   * - this means that for the last page, there are MAX_CARDS_TO_SHOW columns displayed in total (2 columns)
   */

  var totalColumns = canAdd ? totalEntities + 1 : totalEntities;

  var _getPaginationEntitie = getPaginationEntities({
    paginationItemIndex: paginationItemIndex,
    maxEntitiesToShow: maxEntitiesToShow,
    shouldEnableAddEntity: shouldEnableAddEntity,
    updatePaginationItemIndex: updatePaginationItemIndex,
    totalEntities: totalColumns
  }),
      shouldHidePagination = _getPaginationEntitie.shouldHidePagination,
      rightArrow = _getPaginationEntitie.rightArrow,
      leftArrow = _getPaginationEntitie.leftArrow,
      paginationText = _getPaginationEntitie.paginationText;

  var _getPaginationPayload = getPaginationPayload(tabName),
      elementImpressionPayload = _getPaginationPayload.elementImpressionPayload,
      impressionPayload = _getPaginationPayload.impressionPayload;

  return /*#__PURE__*/React.createElement(React.Fragment, null, entitiesToCompare && !shouldHidePagination && /*#__PURE__*/React.createElement(ElementImpression, elementImpressionPayload, /*#__PURE__*/React.createElement(Impression, impressionPayload, /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.compareGridPagination
    }, leftArrow(impressionContext), paginationText, rightArrow(impressionContext)));
  }))));
};